import { SxProps } from '@mui/material'

export const textEllipsisStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const satisfies SxProps
